import * as React from 'react'
import { useSelectLocationsWithServices } from './hooks'
import { ENTITY_TYPES, LocationDTO } from '@sales-center/common'
import { SectionTitle } from './styled'
import Box from '@mui/material/Box'
import { OpportunityFields } from '../OpportunityFields/OpportunityFields'
import { ServiceLocationList } from '../ServiceLocationList'
import { IServiceFrequency } from '@user/store/serviceFrequency'
import { useFormikContext } from 'formik'
import { ISaveServicesForLaterFormModel } from './typings'
import Alert from '@mui/material/Alert'

type Props = {
  disabled: boolean
  entityType: ENTITY_TYPES
  loading: boolean
  localMode: boolean
  serviceFrequencies: IServiceFrequency[]
  serviceLocations: LocationDTO[]
}

export function FormContents(props: Props) {
  const { localMode, serviceLocations } = props

  const locationsWithServices = useSelectLocationsWithServices(
    serviceLocations,
    localMode,
  )

  const { errors, touched } = useFormikContext<ISaveServicesForLaterFormModel>()

  return (
    <>
      <SectionTitle>Select Services</SectionTitle>
      {touched.serviceIds && errors.serviceIds && (
        <Box m={1} ml={0}>
          <Alert severity="error">{errors.serviceIds.toString()}</Alert>
        </Box>
      )}
      <Box>
        <ServiceLocationList
          {...props}
          serviceLocations={locationsWithServices}
        />
      </Box>
      <SectionTitle>Required Fields</SectionTitle>
      <OpportunityFields {...props} />
    </>
  )
}
